import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { getDefaultData } from "components/pages/DisputeTransactionPage/components/DisputeTransactionView";
import DisputeTransactionStartPage from "components/pages/DisputeTransactionPages/DisputeTransactionStartPage";
import { Transaction, TransactionDispute } from "model";

export default function CaptureDisputeTransaction(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Transaction, TransactionDispute ], controller);
        const { branding } = useModel();
    const options = branding.options ?? {};
    
    let transactionID = "98"; // A credit card transaction id.
    if(options.include_credit_chw23 === "false") {
        transactionID = "5"; // A debit card transaction id.
    }
    const data = BCMSStateManagerCRUD.init(getDefaultData(transactionID))
    .submit();

    return (
        <DisputeTransactionStartPage data={ data }/>
    );
}